module.exports = __webpack_public_path__ + "img/pherrol4.d89319f9.jpg";